import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { MenuItemCardProps } from "./MenuItemCard4";

interface SortableItemProps {
  id: string;
  children: React.ReactNode;
}

export const SortableItem: React.FC<SortableItemProps> = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    position: "relative" as const,
  };

  // Clone the children and pass the drag handle properties to it
  return (
    <div ref={setNodeRef} style={style} {...attributes} data-testid="menu-item">
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            dragHandleProps: listeners,
          } as MenuItemCardProps);
        }
        return child;
      })}
    </div>
  );
};
